import React from 'react'

const HeroPlan = () => {
    return (
        <div className="py-5 bg_theme">
            <div className="container py-md-4">
                <h3 className=" fs_44 fw-bold ff_s text-white mb-0 text-center">
                    Ready to set the stage?
                </h3>
                <div className="mx-auto max_w_plan pt-1">
                    <p className=" fs_16 ff_n fw-semibold text-white text-center mb-0 mt-2">
                        Let HKI Events bring your vision to life — whether it's a high-energy youth show, a government mega-conference, or a corporate launch that turns heads.
                    </p>
                    <p className=" fs_16 ff_n fw-semibold text-white text-center mb-0">
                        Fill out the form below and our event architects will reach out to craft something extraordinary.
                    </p>
                </div>
            </div>
        </div>
    )
}

export default HeroPlan